(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["groovela-size-guide"] && !Shopify.designMode) return;
  try {
    class GroovelaSizeGuide extends HTMLElement {
    connectedCallback() {
      try {
        this.chart = JSON.parse(this.querySelector('[data-size-chart]').textContent);
      } catch (error) {
        return;
      }
      this.unit = this.dataset.defaultUnit === 'cm' ? 'cm' : 'in';
      this.rows = new Map(this.chart.rows.map((row) => [String(row.size), row]));
      this.keys = (this.chart.columns || []).map((col) => this.keyFor(col));

      this.addEventListener('click', (event) => this.onClick(event));
      this.onDocumentChange = (event) => this.onVariantChange(event);
      document.addEventListener('change', this.onDocumentChange);

      this.observer = new MutationObserver(() => this.syncFromPicker());
      const picker = this.findPicker();
      if (picker) this.observer.observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });

      this.setUnit(this.unit);
      this.syncFromPicker(true);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onDocumentChange);
      this.observer?.disconnect();
    }

    keyFor(column) {
      const text = String(column).toLowerCase();
      if (text.startsWith('underbust')) return 'underbust';
      if (text.startsWith('length')) return 'length';
      if (text.startsWith('shoulder')) return 'shoulder';
      if (text.startsWith('chest')) return 'chest';
      if (text.startsWith('sleeve')) return 'sleeve';
      if (text.startsWith('waist')) return 'waist';
      if (text.startsWith('hip')) return 'hip';
      if (text.startsWith('bust')) return 'bust';
      return text.split(/[^a-z]/)[0];
    }

    findPicker() {
      const section = this.closest('.shopify-section, product-information, section') || document;
      return section.querySelector('variant-picker') || document.querySelector('variant-picker[data-template-product-match]') || document.querySelector('variant-picker');
    }

    pickerSizeInputs() {
      const picker = this.findPicker();
      if (!picker) return [];
      return Array.from(picker.querySelectorAll('input[type="radio"], option')).filter((el) => /^(size|talla|sizes)$/i.test(el.dataset.optionName || ''));
    }

    selectedSizeFromPicker() {
      const inputs = this.pickerSizeInputs();
      const checked = inputs.find((el) => (el.tagName === 'OPTION' ? el.selected : el.checked));
      return checked ? checked.value : null;
    }

    syncFromPicker(initial = false) {
      const size = this.selectedSizeFromPicker();
      if (size && this.rows.has(size)) {
        this.select(size);
      } else if (initial) {
        this.select(String(this.chart.rows[0].size));
      }
    }

    onVariantChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.closest('variant-picker')) return;
      requestAnimationFrame(() => this.syncFromPicker());
    }

    onClick(event) {
      const unitButton = event.target.closest('[data-unit]');
      if (unitButton) {
        this.setUnit(unitButton.dataset.unit);
        return;
      }
      const tab = event.target.closest('[data-size-tab]');
      const row = event.target.closest('[data-size-row]');
      const size = tab ? tab.dataset.sizeTab : row ? row.dataset.sizeRow : null;
      if (!size) return;
      this.select(size);
      const input = this.pickerSizeInputs().find((el) => el.value === size && el.tagName === 'INPUT');
      if (input && !input.checked && input.getAttribute('aria-disabled') !== 'true') input.click();
    }

    setUnit(unit) {
      this.unit = unit === 'cm' ? 'cm' : 'in';
      this.dataset.unit = this.unit;
      this.querySelectorAll('[data-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.unit === this.unit)));
      if (this.current) this.render();
    }

    select(size) {
      if (!this.rows.has(size)) return;
      this.current = size;
      this.querySelectorAll('[data-size-tab]').forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.sizeTab === size)));
      this.querySelectorAll('[data-size-row]').forEach((row) => row.setAttribute('aria-selected', String(row.dataset.sizeRow === size)));
      this.render();
    }

    format(value) {
      if (value === undefined || value === null || value === '') return '–';
      const number = Number(value);
      if (Number.isNaN(number)) return String(value);
      return (this.unit === 'in' ? number.toFixed(1) : (Math.round(number * 2) / 2).toString()) + ' ' + this.unit;
    }

    render() {
      const row = this.rows.get(this.current);
      if (!row) return;
      const values = row[this.unit] || [];
      const summary = this.querySelector('[data-size-summary]');
      if (summary) {
        const parts = [];
        const lengthIndex = this.keys.indexOf('length');
        const widthIndex = ['chest', 'bust', 'waist', 'hip'].map((k) => this.keys.indexOf(k)).find((i) => i >= 0);
        if (lengthIndex >= 0) parts.push(`${this.format(values[lengthIndex])} long`);
        if (widthIndex !== undefined && widthIndex >= 0) parts.push(`${this.format(values[widthIndex])} ${this.keys[widthIndex]}`);
        summary.textContent = `Size ${this.current} · ${parts.join(' · ')}`;
      }
    }
  }

  if (!customElements.get('groovela-size-guide')) customElements.define('groovela-size-guide', GroovelaSizeGuide);
  } catch(e) { console.error(e); }
})();

})();
